
<app-shared [status]="'Tous'" [type]="'inventaire'"></app-shared>
